import React, { useEffect, useMemo, useState } from "react";

// Import components
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { deleteCheckList, deleteItems, updateCheckList, updateItems } from "store/actions"; // assuming these actions exist
import CreateCheckList from "./CreateCheckList";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const CheckListTable = ({ List,loading,id }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteId,setDeleteId] = useState();
  const [openModal,setOpenModal] = useState()
  const [confirmAction,setConfirmAction] = useState();

  const permissions = JSON.parse(localStorage?.getItem('permissions'));
  const hasEditPermission = permissions.some(item => item?.permissionName === "Edit Checklists");
  const hasDeletePermission = permissions.some(item => item?.permissionName === "Delete Checklists");

  const handleDelete = (checklistId) => {
    dispatch(deleteCheckList(checklistId,id))
    setDeleteId('')
    setOpenModal(false);
    setConfirmAction(false);
  };

    useEffect(()=>{
      if(deleteId && confirmAction){
        handleDelete(deleteId);
      }
    },[deleteId,confirmAction])


  const columns = useMemo(
    () => [
      {
        header: 'Item Name',
        accessorKey: 'checklistItem',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Catalogue',
        accessorKey: 'itemName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      ...(hasEditPermission || hasDeletePermission ? [{
        header: 'Actions',
        id: 'actions',
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            setEditData(rowData);
            setIsOpen(true);
          };

          return (
            <div className="d-flex gap-2">
              {permissions?.map(item=>item?.permissionName)?.includes("Edit Checklists") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18} />
              </Button>}
              {permissions?.map(item=>item?.permissionName)?.includes("Delete Checklists") && <Button color="danger" 
                onClick={()=>{setDeleteId(row?.original?.checklistId); setOpenModal(true);}}
               className="mr-2">
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
    ] : []),
    ],
    [ List]
  );

//   const handleBulkDelete = () => {
//     dispatch(deleteItems(selectedRows));
//     setSelectedRows([]);
//   };

  const handleSubmit = (data) => {
    dispatch(updateCheckList(data)); // Assuming updateItems action exists
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  // Meta title
  document.title = "Checklist Management | Admin Dashboard";

  return (
    <>
      <ConfirmationModal  okText={"Confirm"} onCancel={()=>{setDeleteId(''); setOpenModal(false); }} onOk={()=>{setConfirmAction(true);}} isVisible={openModal} title="Delete Checklist" content='Are You Sure You Want to Delete this Checklist'/>
      <CreateCheckList
        visible={isOpen}
        initialData={editData}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        id={id}
      />
      <div className="">
        <div className="container-fluid">
          <TableContainer
          loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Checklist"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default CheckListTable;
